<button
    type="button"
    #btnColVis
    (keydown.escape)="colVisActive = false"
    (click)="colVisActive = !colVisActive"
    class="btn btn-outline-secondary no-print show-hide-btn"
>
    Show / Hide
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        style="margin-left: 5px"
        fill="currentColor"
        class="bi bi-chevron-down"
        viewBox="0 0 16 16"
    >
        <path
            fill-rule="evenodd"
            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
        />
    </svg>
    <!-- dropdown arrow -->
</button>

@if (colVisActive) {
    <div
        class="show-hide-list-ctnr"
        role="menu"
        [style.left]="btnColVis.offsetLeft + 'px'"
    >
        @for (key of getColDefs(); track key) {
            <label
                class="show-hide-list-item d-block"
                ngbButtonLabel
            >
                <span>{{ columnDefs.get(key).displayName || key }}</span>
                <input
                    (keydown.escape)="colVisActive = false"
                    type="checkbox"
                    [(ngModel)]="columnDefs.get(key).isVisible"
                    (change)="
                        columnDefs.get(key).isVisible = $event.target.checked
                    "
                    ngbButton
                />
            </label>
        }
    </div>
}

@if (colVisActive) {
    <div
        (click)="colVisActive = false"
        class="dt-button-background"
    ></div>
}
